import { render, staticRenderFns } from "./NutritionCounter.vue?vue&type=template&id=25b1b086&"
import script from "./NutritionCounter.vue?vue&type=script&lang=js&"
export * from "./NutritionCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports